import type { ReactNode } from "react";
import React from "react";
import { PagePortalLogin } from "@aspen/pages";

class Login extends React.Component {
  render(): ReactNode {
    return <PagePortalLogin />;
  }
}

export default Login;
